<template>
  <div>
    
    <vue-snotify></vue-snotify>
    

    <div class="row page-title-header">
      <div class="col-12">
        <div class="page-header">
          <b-breadcrumb class="m-0">
            <b-breadcrumb-item
              :to="{
                name: 'DashboardHome',
              }"
            >
              <i class="fa fa-home"></i>
            </b-breadcrumb-item>
            <template v-if="isOAChatroom">
              <b-breadcrumb-item active>LINE 應用中心</b-breadcrumb-item>
              <b-breadcrumb-item active>LINE 聊天</b-breadcrumb-item>
            </template>
            <template v-else>
              <b-breadcrumb-item active>我的主控台</b-breadcrumb-item>
              <b-breadcrumb-item active>聊天室總覽</b-breadcrumb-item>
            </template>
          </b-breadcrumb>
          <div class="ml-auto d-flex align-items-center">
            <b-dropdown
              v-if="$permissions.hasAny([
                $permissions.consts.CHATROOM_LIST_SHOW_MOBILE_CHATROOM_LINK,
                $permissions.consts.CHATROOM_LIST_SHOW_SALES_BIND_LINK
              ])"
              variant="secondary"
              class="mr-3"
            >
              <template slot="button-content">
                <i class="mdi mdi-menu"></i>
              </template>
              <b-dropdown-item v-if="$permissions.has($permissions.consts.CHATROOM_LIST_SHOW_MOBILE_CHATROOM_LINK)" @click="$refs.chatroomUrlModal.showMobileChatroomLink()">
                手機版對話連結
              </b-dropdown-item>
              <b-dropdown-item v-if="$permissions.has($permissions.consts.CHATROOM_LIST_SHOW_SALES_BIND_LINK)" @click="$refs.chatroomUrlModal.showSalesBindLink()">
                {{ salesBindLinkText }}
              </b-dropdown-item>
            </b-dropdown>

            <div
              v-if="
                newestNotification &&
                $permissions.has($permissions.consts.MY_NOTIFICATION_LATEST)
              "
            >
              <router-link
                :to="{
                  name: 'BranchNotificationDetail',
                  params: { notification_id: newestNotification.id },
                }"
              >
                <i
                  :class="{
                    'fa fa-envelope-o text-danger': !newestNotification.is_read,
                    'fa fa-envelope-open-o text-black':
                      newestNotification.is_read,
                  }"
                ></i>
                <a
                  class="ml-2 text-black"
                  :class="{
                    'text-danger': !newestNotification.is_read,
                  }"
                >
                  {{ newestNotification.title }} :
                  {{
                    format(new Date(newestNotification.publish_at), "MM/dd HH:mm")
                  }}
                </a>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-card
      no-body
      ref="chatroom"
      class="chatroom"
      @mouseup="isLeftDragging = isRightDragging = isBottomDragging = false"
      @mousemove="onDrag"
    >
      <div ref="chatlist" class="chat-list position-relative border-right">
        <div class="chat-list-wrapper d-flex flex-column h-100">
          <div class="header px-3 pt-3 pb-2 border-bottom">
            <div class="search mb-2">
              <b-form-select
                v-if="canShowBranchSelector"
                :value="selectedBranch"
                :options="branchOptions"
                :disabled="changingBranch"
                @change="handleChangeSelectedBranch"
              >
                <template #first>
                  <b-form-select-option :value="null" disabled
                    >-- 選擇分店 --</b-form-select-option
                  >
                  <b-form-select-option value="unallocated" v-if="isOAChatroom"
                    >尚未分配</b-form-select-option
                  >
                </template>
              </b-form-select>
            </div>

            <div class="search mb-2">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path
                  d="M500.3 443.7l-119.7-119.7c27.22-40.41 40.65-90.9 33.46-144.7C401.8 87.79 326.8 13.32 235.2 1.723C99.01-15.51-15.51 99.01 1.724 235.2c11.6 91.64 86.08 166.7 177.6 178.9c53.8 7.189 104.3-6.236 144.7-33.46l119.7 119.7c15.62 15.62 40.95 15.62 56.57 0C515.9 484.7 515.9 459.3 500.3 443.7zM79.1 208c0-70.58 57.42-128 128-128s128 57.42 128 128c0 70.58-57.42 128-128 128S79.1 278.6 79.1 208z"
                />
              </svg>
              <b-form-input
                type="search"
                v-model.trim="keyword"
                placeholder="姓名搜尋"
                @input="keywordSearchDebounced"
              ></b-form-input>
            </div>
            <div class="d-flex flex-wrap">
              <div class="flex-fill mr-2">
                <ChatroomMultiselect
                  v-if="allowFilterCategory"
                  title="訊息類型"
                  :filters="filterCategoryOptions"
                  :showKeywordFilter="false"
                  :selectedOptions="selectedCategoryFilter"
                  @click="handleSelectedCategory"
                />
              </div>

              <div class="flex-fill mr-2">
                <ChatroomMultiselect
                  v-if="allowFilterStatus"
                  title="處理狀態"
                  :filters="statusOptions"
                  :showKeywordFilter="false"
                  :selectedOptions="selectedStatus"
                  @click="handleSelectedStatus"
                />
              </div>

              <!-- <div v-if="false" class="d-flex align-items-center">
                <input
                  type="checkbox"
                  name="showUnreadChatroom"
                  v-model="filteredUnreadChatroom"
                  @change="handleUnreadFilter"
                /><span>未讀</span>
              </div> -->

              <div v-if="canShowUnreadFilter" class="d-flex align-items-center">
                <button
                  id="filteredUnreadChatroom"
                  @click="handleSelectedStatus(statusOptions.find((status)=>status.value=='unread'))"
                  class="btn btn-outline-secondary unread px-2"
                  :class="filteredUnreadChatroom ? 'active' : ''"
                >
                  <!-- <i class="fa fa-check"></i> -->
                  <img                    
                    class="img-fluid icon-all"
                    src="data:image/png;base64,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"
                    alt="顯示未讀訊息"
                  />
                  <img                    
                    class="img-fluid icon-unread"
                    src="data:image/png;base64,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"
                    alt="顯示全部訊息"
                  />
                
                </button>
                <b-tooltip target="filteredUnreadChatroom" triggers="hover">
                  {{ filteredUnreadChatroom ? "顯示全部訊息" : "顯示未讀訊息" }}
                </b-tooltip>
              </div>
            </div>

            <div v-if="false" class="filter">
              <b-dropdown id="dropdown-1" text="所有收件匣" variant="light">
                <b-dropdown-item v-for="i in filters" :key="i.id">
                  <i :class="[i.icon]" aria-hidden="true"></i> {{ i.id }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <b-list-group
            class="list list-group-flush flex-fill"
            @scroll="handleChatroomListScroll"
            ref="chatroomList"
          >
            <b-list-group-item
              v-if="
                !initialized ||
                changingBranch ||
                changingFilter ||
                keywordFilter
              "
              class="empty"
            >
              <div class="text-center">
                <b-spinner variant="secondary" small />
              </div>
            </b-list-group-item>
            <template v-else-if="orderedChatrooms.length > 0">
              <div
                v-for="chatroom in orderedChatrooms"
                :key="chatroom.id"
                @click="selectChatroom(chatroom)"
              >
                <ChatroomListItem
                  role="button"
                  :chatroom="chatroom"
                  :variant="chatroomId == chatroom.id ? 'secondary' : 'default'"
                  :staffID="staffId"
                  :categories="categoryFilterOptions"
                />
              </div>
              <div class="text-center mt-3 mb-3 loading-spinner" v-if="loading">
                <b-spinner variant="secondary" small />
              </div>
            </template>
            <b-list-group-item v-else class="empty">
              <!-- <img src="./images/empty.svg" /> -->
              <div class="mt-3 text-dark small">目前沒有名單</div>
            </b-list-group-item>
          </b-list-group>
        </div>
      </div>

      <div class="left-dragbar" @mousedown="isLeftDragging = true">
        <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
      </div>

      <div class="chat-box d-flex flex-column">
        <div class="chat-header">
          <div
            class="d-flex justify-content-between px-3 py-2 pe-0 border-bottom"
          >
            <div v-if="selectedChatroom" class="font-weight-bold text-truncate">
              <b-avatar class="mr-1">
                <img
                  :src="getStaffAvatar(selectedChatroom)"
                  class="img-fluid"
                />
              </b-avatar>
              <b-avatar class="mr-3">
                <img
                  :src="getCustomerAvatar(selectedChatroom)"
                  class="img-fluid"
                />
              </b-avatar>
              {{ getChatroomTitle(selectedChatroom, true) }}
            </div>

            <div
              v-if="selectedChatroom"
              class="d-flex flex-fill justify-content-end align-items-center"
            >
              <b-button
                v-if="false"
                class="py-1"
                @click="
                  () => {
                    let msg = Object.assign(messages[1]);
                    messages = [msg].concat(messages);
                    unread = true;
                  }
                "
              >
                Test Message</b-button
              >

              <b-button
                @click="handleClickPin"
                v-if="canShowPinButton"
                class="mx-1 text-nowrap"
                :disabled="
                  !selectedChatroom.is_enabled ||
                  !canShowChatReply ||
                  !isSenderEnabled
                "
                :variant="`${
                  isSelectedChatroomPinned ? 'warning' : 'outline-warning'
                }`"
              >
                {{ isSelectedChatroomPinned ? "取消釘選" : "釘選" }}
                <i
                  class="fa fa-thumb-tack"
                  style="transform: rotate(45deg)"
                  aria-hidden="true"
                ></i>
              </b-button>
              <template v-if="canShowStatusButtons">
                <b-dropdown
                  class="filter mx-1"
                  ref="Filter"
                  :disabled="
                    !selectedChatroom.is_enabled ||
                    !canShowChatReply ||
                    !isSenderEnabled
                  "
                  :variant="`${selectedChatroomStatusVariant} py-1`"
                >
                  <template #button-content>
                    <div class="flex-fill">
                      {{ selectedChatroomStatusName }}
                    </div>
                  </template>

                  <div
                    v-for="status in statusOptions.filter(status => status.value !== 'unread')"
                    :key="status.value"
                    @click="handleClickChangeStatus(status.value)"
                    class="item py-1 px-3"
                  >
                    <span
                      class="d-flex justify-content-between align-items-center"
                    >
                      <i
                        :class="`${
                          selectedChatroomStatus === status.value ||
                          (!selectedChatroomStatus &&
                            status.value === 'not-setting')
                            ? 'fa fa-check'
                            : ''
                        } mr-3`"
                        aria-hidden="true"
                      ></i>
                      <span
                        :class="`mb-0 px-3 py-2 badge badge-${status.variant} flex-fill cursor-pointer`"
                        >{{ status.text }}</span
                      >
                    </span>
                  </div>
                </b-dropdown>
              </template>

              <div class="d-flex justify-content-end">
                <div v-if="showRecallCheckBox">
                  <b-button
                    @click="switchShowRecallCheckBox"
                    :disabled="
                      !selectedChatroom.is_enabled ||
                      !canShowChatReply ||
                      !isSenderEnabled
                    "
                    class="m-1"
                    variant="outline-danger"
                  >
                    取消
                  </b-button>
                  <b-button
                    :disabled="
                      !selectedChatroom.is_enabled ||
                      !canShowChatReply ||
                      !isSenderEnabled
                    "
                    @click="recallMessage"
                    class="m-1"
                    variant="danger"
                  >
                    收回
                  </b-button>
                </div>
                <template v-if="canShowRecall">
                  <b-dropdown
                    :disabled="
                      !selectedChatroom.is_enabled ||
                      !canShowChatReply ||
                      !isSenderEnabled
                    "
                    ref="settingDropdown"
                    variant="secondary py-1"
                  >
                    <template #button-content>
                      <div class="flex-fill">
                        <i class="fa fa-gear" aria-hidden="true"></i>
                      </div>
                    </template>
                    <span
                      class="
                        d-flex
                        justify-content-between
                        align-items-center
                        text-center
                      "
                      @click="switchShowRecallCheckBox"
                    >
                      <span :class="`mb-0 px-3 py-2 flex-fill cursor-pointer`"
                        >收回訊息</span
                      >
                    </span>
                  </b-dropdown>
                </template>
              </div>

              <b-button
                v-if="false"
                variant="outline-dark"
                class="mx-1 text-nowrap"
                @click="
                  () => {
                    isMessageSearching = !isMessageSearching;
                  }
                "
              >
                <i class="fa fa-search" aria-hidden="true"></i>
                搜尋</b-button
              >

              <b-button v-if="false" variant="light" class="mx-1">
                <i class="fa fa-sign-in m-0" aria-hidden="true"></i>
              </b-button>
              <b-button v-if="false" variant="light" class="mx-1">
                <i class="fa fa-check m-0 text-success" aria-hidden="true"></i>
              </b-button>
            </div>
          </div>

          <div
            v-if="isMessageSearching"
            class="search-message p-2 border-bottom d-flex"
          >
            <b-form-input
              size="sm"
              type="search"
              class="flex-fill"
              placeholder="輸入搜尋內容"
            />
            <b-button
              class="btn btn-light ml-2"
              @click="
                () => {
                  isMessageSearching = !isMessageSearching;
                }
              "
              ><i class="fa fa-remove"></i
            ></b-button>
          </div>
        </div>

        <div
          ref="messages"
          class="messages d-flex flex-column-reverse flex-fill px-3"
          @scroll="handleScroll"
        >
          <div
            class="message-box my-2"
            v-if="chatroomLoaded && !messages.length"
          >
            <div class="strike small text-muted pb-2">對話開始</div>
          </div>
          <ChatroomMessage
            v-for="(message, idx) in messages"
            v-bind:key="idx"
            :messages="messages"
            :message="message"
            :index="idx"
            :senders="senders"
            :showMultiDownload="canShowMultiDownload"
            :showThumbnailMultiDownload="canShowThumbnailMultiDownload"
            :showRecall="showRecallCheckBox"
            :canRecallHours="canShowRecallHours"
            @change="pushRecallMessage"
            :first-unread-message="firstUnreadMessage"
            :selectedRecallMessages="selectedRecallMessages"
            :messageRecalling="messageRecalling"
            :first-message="firstMessage"
            :first-load="firstLoad"
            :first-new-message="firstNewMessage"
          >
          </ChatroomMessage>

          <div class="typing-list" v-if="typingSenders.length">
            <div
              class="message-box my-2"
              :key="sender.id"
              v-for="sender in typingSenders"
            >
              <div class="message-wrapper">
                <div class="d-flex align-items-start">
                  <b-avatar class="mr-2" :src="sender.avatar_url" />
                  <div>
                    <small>{{ senderName(sender) }}</small>
                    <div class="message py-2 px-3 mt-1">
                      <Typing />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="text-muted small load-more"
            v-if="selectedChatroom && !loading"
          >
            <button
              class="btn btn-secondary btn-small"
              @click.prevent="loadMore"
              v-if="nextCursor"
            >
              載入之前的對話
            </button>
            <span v-else-if="!firstLoad">已無對話紀錄</span>
          </div>

          <div class="text-center mt-3 mb-auto loading-spinner" v-if="loading">
            <b-spinner variant="secondary" small />
          </div>
        </div>

        <StickerPanel
          :sticker-packages="stickerPackages"
          :stickers="stickers"
          @package-selected="fetchStickers"
          @sticker-selected="handleStickerSelected"
          @close="showStickerPanel = false"
          v-show="showStickerPanel"
        />
      </div>

      <div class="bottom-dragbar" @mousedown="isBottomDragging = true">
        <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
      </div>

      <div ref="chatTypebox" class="chat-typebox">
        <div class="border-top chat-typebox-wrapper d-flex flex-column">
          <div
            class="position-absolute unread d-flex justify-content-center px-3"
            v-if="showIndicator"
          >
            <b-button
              v-if="unread"
              variant="dark"
              size="sm"
              pill
              @click="scrollToBottom"
            >
              <div class="last-message-wrapper">
                {{ latestMessage.sender.name }}：{{ latestMessage.content }}
              </div>
            </b-button>

            <b-button
              v-else-if="!bottom"
              variant="dark"
              size="sm"
              class="px-2"
              pill
              @click="scrollToBottom"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                height="16"
                fill="white"
              >
                <!--! Font Awesome Pro 6.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                <path
                  d="M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"
                />
              </svg>
            </b-button>
          </div>
          <template
            v-if="
              selectedChatroom &&
              (allowSendMessage || allowSendImage || allowSendFile)
            "
          >
            <div
              class="
                p-2
                chat-typebox-buttons
                flex-shrink-0
                list-group-item-secondary
              "
            >
              <b-modal
                id="modal-image-upload"
                title="傳送照片"
                class="modal-image"
                centered
                hide-footer
                ref="imageModal"
              >
                <div v-if="uploading">上傳中...</div>
                <b-form-file
                  drop-placeholder="Drop file here..."
                  class="uploader"
                  accept="image/*"
                  @input="handleUpload"
                  ref="imageUploader"
                  multiple
                  placeholder="尚未選擇檔案"
                  browse-text="瀏覽"
                  v-else
                >
                  <template slot="placeholder">
                    <div
                      class="
                        dropzone
                        d-flex
                        flex-column
                        align-items-center
                        justify-content-center
                      "
                    >
                      <div>請將檔案拖放至此</div>
                      <div>或</div>
                      <div>選擇檔案</div>
                    </div>
                  </template>
                  <template slot="file-name" slot-scope="{ names }">
                    <b-badge variant="dark">{{ names[0] }}</b-badge>
                  </template>
                </b-form-file>
              </b-modal>

              <b-modal
                id="modal-file-upload"
                title="傳送檔案"
                class="modal-image"
                centered
                hide-footer
                ref="fileModal"
              >
                <div v-if="uploading">上傳中...</div>
                <b-form-file
                  drop-placeholder="Drop file here..."
                  class="uploader"
                  @input="handleUpload"
                  ref="fileUploader"
                  multiple
                  v-else
                  placeholder="尚未選擇檔案"
                  browse-text="瀏覽"
                >
                  <template slot="placeholder">
                    <div
                      class="
                        dropzone
                        d-flex
                        flex-column
                        align-items-center
                        justify-content-center
                      "
                    >
                      <div>請將檔案拖放至此</div>
                      <div>或</div>
                      <div>選擇檔案</div>
                    </div>
                  </template>
                  <template slot="file-name" slot-scope="{ names }">
                    <b-badge variant="dark">{{ names[0] }}</b-badge>
                  </template>
                </b-form-file>
              </b-modal>
              <template v-if="selectedChatroom && canShowChatReply">
                <button
                  class="btn btn-link px-2 text-dark"
                  :disabled="!selectedChatroom.is_enabled"
                  @click.prevent="showStickerPanel = !showStickerPanel"
                >
                  <i class="fa fa-smile-o" aria-hidden="true"></i>
                </button>
                <button
                  v-if="allowSendImage"
                  v-b-modal.modal-image-upload
                  class="btn btn-link px-2 text-dark"
                  :disabled="!selectedChatroom.is_enabled"
                >
                  <i class="fa fa-picture-o" aria-hidden="true"></i>
                </button>
                <button
                  v-if="allowSendFile"
                  v-b-modal.modal-file-upload
                  class="btn btn-link px-2 text-dark"
                  :disabled="!selectedChatroom.is_enabled"
                >
                  <i class="fa fa-paperclip" aria-hidden="true"></i>
                </button>
              </template>
            </div>
            <div
              class="py-2 pl-2 border-top d-flex align-items-stretch flex-fill"
            >
              <form @submit.prevent class="flex-fill message-form">
                <b-form-textarea
                  class="message-box"
                  :style="`--lines: ${messageLines}`"
                  :placeholder="showTextPlaceholder"
                  ref="input"
                  v-model="message"
                  v-if="allowSendMessage"
                  :disabled="
                    !selectedChatroom.is_enabled ||
                    !canShowChatReply ||
                    !isSenderEnabled
                  "
                  rows="1"
                  @keypress="handleInputKeypress"
                ></b-form-textarea>
              </form>

              <button
                class="btn"
                type="button"
                :disabled="
                  sending || !selectedChatroom.is_enabled || !canShowChatReply
                "
                v-if="allowSendMessage"
                @click="send"
              >
                <svg
                  width="21"
                  height="18"
                  viewBox="0 0 21 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.17 6.22991L5.17001 0.449907C4.64029 0.230693 4.05884 0.167851 3.49451 0.26882C2.93018 0.369788 2.4066 0.630339 1.98575 1.01963C1.5649 1.40891 1.2644 1.91064 1.11983 2.4654C0.975262 3.02016 0.992675 3.60473 1.17001 4.14991L2.71001 8.99991L1.13001 13.8499C0.947881 14.3973 0.927422 14.9855 1.07108 15.5442C1.21475 16.1029 1.51644 16.6083 1.94001 16.9999C2.48465 17.505 3.19729 17.79 3.94001 17.7999C4.33474 17.7996 4.72554 17.7215 5.09001 17.5699L19.14 11.7899C19.6872 11.5623 20.1547 11.1778 20.4836 10.6848C20.8125 10.1919 20.988 9.61252 20.988 9.01991C20.988 8.42729 20.8125 7.84795 20.4836 7.35497C20.1547 6.862 19.6872 6.47747 19.14 6.24991L19.17 6.22991ZM4.36001 15.6999C4.18361 15.7727 3.99007 15.7934 3.80225 15.7598C3.61442 15.7261 3.44015 15.6394 3.30001 15.5099C3.168 15.3838 3.07304 15.2239 3.02545 15.0476C2.97785 14.8713 2.97943 14.6854 3.03001 14.5099L4.49001 9.99991H18.22L4.36001 15.6999ZM4.49001 7.99991L3.00001 3.52991C2.94943 3.35446 2.94785 3.16851 2.99545 2.99222C3.04304 2.81594 3.138 2.65606 3.27001 2.52991C3.36412 2.43118 3.47742 2.35275 3.60296 2.29944C3.7285 2.24613 3.86362 2.21906 4.00001 2.21991C4.13406 2.22016 4.26669 2.24737 4.39001 2.29991L18.22 7.99991H4.49001Z"
                    fill="#09101D"
                  />
                </svg>
              </button>
            </div>
          </template>
        </div>
      </div>

      <div class="right-dragbar" @mousedown="isRightDragging = true">
        <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
      </div>

      <div ref="sideCol" class="side-col border-left">
        <div class="side-col-wrapper">
          <ChatroomSidebox
            :selected-chatroom="selectedChatroom"
            :chatroom-config="chatroomConfig"
            :show-file-list-in-dashboard="showFileListInDashboard"
            :show-member-list-in-dashboard="showMemberListInDashboard"
            @updateMessageNickname="syncMessageNickname"
            ref="sidebox"
          />
        </div>
      </div>
    </b-card>
    <ImageLightBox ref="lightbox" />
    <ChatroomUrlModal ref="chatroomUrlModal" />
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapState, mapGetters } from "vuex";
import {CHATROOM_TYPE_TYPE_OA} from "@/consts"
import "bootstrap-vue/dist/bootstrap-vue.css";
import chatroomApi from "@/apis/chatrooms";
import moduleApi from "@/apis/module";
import meApi from "@/apis/me";
import format from "date-fns/format";
import ChatroomListItem from "@/components/Page/Chatroom/ChatroomListItem.vue";
import ChatroomMessage from "@/pages/Dashboard/Chatrooms/Components/ChatroomMessage.vue";
import ChatroomSidebox from "@/pages/Dashboard/Chatrooms/Components/ChatroomSidebox.vue";
import ChatroomUrlModal from "@/pages/Dashboard/Chatrooms/Components/ChatroomUrlModal.vue";
import ChatroomMultiselect from "@/components/Page/Chatroom/ChatroomMultiselect.vue";
import {
  getChatroomAvatar,
  getChatroomTitle,
  formatDate,
  getStaffAvatar,
  getCustomerAvatar,
} from "@/utils/chatroomHelper.js";
import Echo from "laravel-echo";
import store from "@/store";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import chatoomMixin from "@/mixins/chatroom";

import {
  CHATROOM_STATUS,
  chatroomStatusTextMapping,
  chatroomStatusVariantMapping,
} from "@/pages/Dashboard/Chatrooms/Chatroom.utils";
import _ from "lodash";
import { handleCustomUpload } from "@/utils/ImageHelper";
import Snotify, { SnotifyPosition, SnotifyStyle } from 'vue-snotify'
const options = {
  toast: {
    position: SnotifyPosition.rightTop,
    type: SnotifyStyle.warning
  }
}
Vue.use(Snotify, options)


global.Pusher = require("pusher-js");

// 未讀通知預設值
const DEFAULT_UNREAD_NOTIFICATION_INTERVAL = 10; // 預設 10 分鐘

export default {
  mixins: [chatoomMixin],
  components: {
    ChatroomListItem,
    ChatroomMultiselect,
    ChatroomMessage,
    ChatroomSidebox,
    ChatroomUrlModal,
  },
  data() {
    return {
      currentImg: "",
      me: null,
      bottom: true,
      loading: false,
      sending: false,
      uploading: false,
      selectedChatroomID: "",
      selectedMember: false,
      selectedBranch: null,
      chatroomConfig: null, // module_config
      messages: [],
      filters: [
        { id: "所有收件匣", icon: "fa fa-inbox" },
        { id: "未指派", icon: "fa fa-clock-o" },
        { id: "完成", icon: "fa fa-check-circle-o" },
        { id: "所有已指派", icon: "fa fa-files-o" },
        { id: "被指派", icon: "fa fa-sign-in" },
        { id: "聊天機器人", icon: "fa fa-android" },
        { id: "垃圾匣", icon: "fa fa-trash-o" },
        { id: "顧客已封鎖", icon: "fa fa-ban" },
      ],
      keyword: null,
      message: null,
      isMessageSearching: false,
      m_pos: null,
      leftWidth: null,
      unread: false,
      nextCursor: null,
      echo: null,
      channel: null,
      stateBag: [],
      allowSendMessage: false,
      showMemberListInDashboard: false,
      showFileListInDashboard: false,
      allowSendImage: false,
      allowSendFile: false,
      fileList: [],
      CHATROOM_STATUS,
      chatroomStatusTextMapping,
      chatroomStatusVariantMapping,
      perPage: 10,
      currentPage: 1,
      total: 0,
      initialized: false,
      chatroomNextCursor: null,
      selectedBranchID: "",
      changingBranch: false,
      selectedImageUrls: [],
      allowFilterCategory: false,
      changingFilter: false,
      everyMinFetchChatroomTimer: null,
      categoryFilterOptions: [],
      selectedCategoryFilter: [],
      selectedStatus: [],
      statusOptions: [
        { text: "待處理", value: "pending", variant: "danger" },
        { text: "處理中", value: "doing", variant: "warning" },
        { text: "處理完畢", value: "done", variant: "primary" },
        { text: "未設定", value: "not-setting", variant: "secondary" },
        { text: "未讀訊息", value: "unread", variant: "success" },
      ],
      allowFilterStatus: false,
      selectedChatroom: null,
      keywordFilter: false,
      orderedChatrooms: [],
      selectedRecallMessages: [],
      showRecallCheckBox: false,
      canRecallHours: 0,
      messageRecalling: false,
      chatroomLoaded: false,
      
      handlingState: null,

      //Drag
      isLeftDragging: false,
      isRightDragging: false,
      isBottomDragging: false,
      typeboxHeight: 130,

      // 未讀通知
      unreadNotificationTimer: null,
      notificationPermission: null,
    };
  },

  computed: {
    ...mapState("general", {
      newestNotification: (state) => state.newestNotification,
      myBranches: (state) => state.myBranches,
    }),
    ...mapGetters("general", ["branchOptions"]),
    staffId() {
      return store.state.auth.user.id;
    },
    isOAChatroom() {
      return this.$route.name == 'OAChatroomIndex'
    },
    chatroomId() {
      return this.selectedChatroom?.id;
    },
    senderId() {
      return store.state.auth.user.id;
    },
    senders() {
      return this.selectedChatroom?.senders;
    },
    selectedChatroomStatus() {
      return this.selectedChatroom?.status;
    },
    selectedChatroomStatusName() {
      return chatroomStatusTextMapping[this.selectedChatroomStatus] ?? "未設定";
    },
    selectedChatroomStatusVariant() {
      return (
        chatroomStatusVariantMapping[this.selectedChatroomStatus] ?? "secondary"
      );
    },

    canShowPinButton() {
      if (!this.chatroomConfig) {
        return false;
      }

      return this.chatroomConfig.allow_staff_pin_in_dashboard ?? false;
    },

    canShowStatusButtons() {
      if (!this.chatroomConfig) {
        return false;
      }

      return this.chatroomConfig.allow_staff_set_status_in_dashboard ?? false;
    },

    canShowBranchSelector() {
      return this.$permissions.has(
        this.$permissions.consts.CHATROOM_LIST_CHAT_BRANCH_LIST
      );
    },

    isSelectedChatroomPinned() {
      return !!this.selectedChatroom?.extensions[0]?.pinned_at;
    },
    canShowChatReply() {
      // 是否有亂入權限
      const notSenderReply = this.$permissions.has(
        this.$permissions.consts.CHATROOM_LIST_CHAT_NOT_SENDER_REPLY
      );
      // 有 繼續判斷能不能聊天
      if (notSenderReply) {
        return this.$permissions.has(
          this.$permissions.consts.CHATROOM_LIST_CHAT_REPLY
        );
      } else {
        // 沒有 看自己是否在聊天室內 不在也不能聊天
        const sender = this.selectedChatroom?.senders.find(
          (s) => s.id === this.staffId
        );
        if (sender) {
          return this.$permissions.has(
            this.$permissions.consts.CHATROOM_LIST_CHAT_REPLY
          );
        } else {
          return false;
        }
      }
    },
    showIndicator() {
      return this.scrollTop < -100;
    },
    canShowMultiDownload() {
      if (!this.chatroomConfig) {
        return false;
      }

      return (
        this.chatroomConfig.allow_batch_download_images_in_dashboard ?? false
      );
    },
    canShowThumbnailMultiDownload() {
      return this.chatroomConfig
        && (
          this.chatroomConfig.allow_batch_download_thumbnail_images_in_dashboard ?? false
        );
    },
    canShowRecall() {
      if (!this.chatroomConfig) {
        return false;
      }

      if (!this.chatroomConfig.recall_message) {
        return false;
      }

      return this.chatroomConfig.recall_message["enable"] ?? false;
    },
    canShowRecallHours() {
      if (!this.chatroomConfig) {
        return 0;
      }

      if (!this.chatroomConfig.recall_message) {
        return 0;
      }

      return this.chatroomConfig.recall_message["can_recall_time_by_hour"] ?? 0;
    },
    canShowUnreadFilter() {
      return this.chatroomConfig?.show_unread_filter_in_dashboard ?? false;
    },
    selectedCategoryValue() {
      return this.selectedCategoryFilter.map(({ value }) => value).join(",");
    },
    filterCategoryOptions() {
      return this.categoryFilterOptions.map((option) => {
        return {
          value: option.key,
          text: option.display_name,
        };
      });
    },
    selectedStatusValue() {
      return this.selectedStatus
        .map(({ value }) => value)
        .filter((x) => x != "unread")
        .join(",");
    },
    showTextPlaceholder() {
      if (!this.selectedChatroom.is_enabled) {
        return "聊天室已關閉";
      } else {
        if (this.canShowChatReply && this.isSenderEnabled) {
          return "輸入留言";
        } else {
          return "您無法傳送訊息";
        }
      }
    },
    isSenderEnabled() {
      if (this.selectedChatroom) {
        const sender = this.selectedChatroom.senders.find(
          (s) => s.id === this.staffId
        );
        if (sender) {
          return sender.is_enabled;
        } else {
          return true;
        }
      }
      return false;
    },
    filteredUnreadChatroom() {
      return this.selectedStatus.find((s) => s.value === "unread");
    },
    salesBindLinkText() {
      const lineId = this.me?.line_id;
      if (lineId !== null && lineId !== undefined && String(lineId).trim() !== "") {
        return "已啟用 LINE 綁定";
      }
      return "業務啟用連結";
    }
  },
  created() {
    this.fetchMeForChatroom();
    this.init();
    this.keywordSearchDebounced = _.debounce(async () => {
      this.keywordFilter = true;
      await this.fetchChatrooms();
      this.keywordFilter = false;
    }, 1000);
  },

  methods: {
    getChatroomTitle,
    getChatroomAvatar,
    formatDate,
    getStaffAvatar,
    getCustomerAvatar,
    format,
    getStickerPackages: chatroomApi.getStickerPackages,
    getStickers: chatroomApi.getStickers,
    keywordSearchDebounced() {},
    ...mapActions("faviconBadge", ["showBadge", "hideBadge"]),

    async init() {
      this.initialized = false;

      this.initializeEcho();
      this.fetchChatroomConfig();
      await this.firstFetchChatrooms();
      this.regularFetchChatroomTrigger();
      this.listenForStaffChannelEvents();
      this.initialized = true;
      this.sortingChatrooms();
      this.initRowSizes();
      this.fetchStickerPackages();
      this.initUnreadNotification();
    },
    async fetchMeForChatroom() {
      try {
        const response = await meApi.getProfile();
        this.me = response.data?.data ?? null;
      } catch (error) {
        this.me = null;
        console.error("[chatroom] fetch me failed:", error);
      }
    },

    /**
     * 初始撈聊天室邏輯
     *
     * CHATROOM_LIST_CHAT_ORG權限判斷
     *  有 -> 撈全部
     *  無 -> 往下看 CHATROOM_LIST_CHAT_BRANCH_LIST
     *
     * CHATROOM_LIST_CHAT_BRANCH_LIST 權限判斷
     *  有 -> 用第一個分店撈
     *  無 -> 撈自己的
     */
    async firstFetchChatrooms() {
      if (
        this.$permissions.has(this.$permissions.consts.CHATROOM_LIST_CHAT_ORG)
      ) {
        this.listenForOrgChannelEvents(store.state.general.organization.id);
        await this.fetchChatrooms();
        this.defaultCategoryFilter();
        return;
      }

      if (
        this.$permissions.has(
          this.$permissions.consts.CHATROOM_LIST_CHAT_BRANCH_LIST
        )
      ) {
        if (this.branchOptions[0].value ?? null) {
          this.selectedBranch = this.branchOptions[0].value;
          this.selectedBranchID = this.selectedBranch;
          this.listenForBranchChannelEvents(this.selectedBranch);
          await this.fetchChatrooms(this.selectedBranch);
          this.defaultCategoryFilter();
          return;
        }
      }

      await this.fetchChatrooms();
      this.defaultCategoryFilter();
    },

    async handleChangeSelectedBranch(selectedBranch) {
      if (this.changingBranch) return;
      this.changingBranch = true;
      this.selectedBranch = selectedBranch;
      this.messages = [];
      this.echo.leave(`branch.${this.selectedBranchID}`);
      this.listenForBranchChannelEvents(this.selectedBranch);
      this.selectedBranchID = this.selectedBranch;
      await this.fetchChatrooms(this.selectedBranch);
      this.$nextTick(() => this.$refs.chatroomList.scrollTo(0, 0));
      this.changingBranch = false;
    },

    async fetchChatroomConfig() {
      let { data } = await moduleApi.getModuleConfig({
        module_code: "chatroom",
      });

      this.chatroomConfig = data;
    },

    async selectChatroom(chatroom) {
      if (chatroom.id === this.selectedChatroomID) {
        return;
      }

      this.firstLoad = true;
      this.chatroomLoaded = false;

      while (this.loading) {
        await this.sleep(100);
      }
      this.leaveChannel();
      this.selectedChatroomID = chatroom.id;
      this.selectedChatroom = this.chatrooms.find(
        (chatroom) => chatroom.id === this.selectedChatroomID
      );
      this.fetchSingleChatroom();
      await this.fetchMessages();
      // this.fetchFileList();
      this.clearTypingSenders();
      this.clearTimers();
      this.connectToChannel();
      this.listenForChannelEvents();
      // this.fetchCustomers();
      // this.fetchStaffs();
      // this.resetCurrentCustomer();
      this.setSenderLastReadAt();
      this.setLastLatestMessageSentAt();
      this.scrollToUnreadMessage();
      this.read();
      this.message = "";
      this.stateBag = [];
      this.selectedRecallMessages = [];
      this.showRecallCheckBox = false;
      this.chatroomLoaded = true;
      this.showStickerPanel = false;

      this.resetRowSizes();
    },

    // 離開並重置當前所選聊天室的狀態
    async resetSelectedChatroom() {
      this.leaveChannel();
      this.selectedChatroomID = null;
      this.selectedMember = false;
      this.messages = [];
      this.staffs = [];
      this.customers = [];
      this.stateBag = [];
      this.message = "";
      this.nextCursor = null;
      this.selectedImageUrls = [];
      this.firstLoad = true;
      this.chatroomLoaded = false;
    },

    async handleMessageReceivedUpdateTab(event) {
      let { message, chatroom, sender, state } = event;
      if (this.handlingState == state) return;
      this.handlingState = state;
      let targetChatroom = this.chatrooms.find((c) => c.id === chatroom.id);

      // 因為這裡會有重複新增的問題，所以需要確認最新那則 message 與目前這則不一樣，才 increaseUnreadCount
      if (targetChatroom && targetChatroom.message?.id !== message.id) {
        this.increaseUnreadCount(chatroom, sender);
      }

      let newChatroom = null;
      if (!targetChatroom) {
        let response = await chatroomApi.getSingleChatrooms(chatroom.id);

        console.log(response);

        //如果沒有 要判斷一下新的Chatroom 是否符合 User Category
        const category = response.data.data.category;
        const status = response.data.data.status;
        if (this.categoryFilterOptions.find((o) => o.key === category)) {
          // 追加判斷目前的篩選狀態 status & category
          // 判斷加入unread
          if (
            (this.selectedStatus.find((s) => s.value === status) ||
              this.selectedStatus.find((s) => s.value === "unread")) &&
            this.selectedCategoryFilter.find((c) => c.value === category)
          ) {
            newChatroom = response.data.data;
          } else if (
            (this.selectedStatus.find((s) => s.value === status) ||
              this.selectedStatus.find((s) => s.value === "unread")) &&
            !this.selectedCategoryFilter.length
          ) {
            newChatroom = response.data.data;
          } else if (
            this.selectedCategoryFilter.find((c) => c.value === category) &&
            !this.selectedStatus.length
          ) {
            newChatroom = response.data.data;
          }

          //都篩選條件 直接新增
          if (
            !this.selectedStatus.length &&
            !this.selectedCategoryFilter.length
          ) {
            newChatroom = response.data.data;
          }
        }
      } else {
        Object.assign(targetChatroom, { message: message });
      }
      if (newChatroom) {
        this.chatrooms.unshift(newChatroom);
      }

      this.sortingChatrooms();
    },

    increaseUnreadCount(chatroom, sender) {
      if (
        this.selectedChatroomID === chatroom.id ||
        this.senderId === sender.id
      ) {
        return;
      }
      let targetSender = this.chatrooms
        .find((c) => c.id === chatroom.id)
        .senders.find((s) => s.id === this.staffId);

      if (targetSender) {
        let count = 0;
        if (!("unread_count" in targetSender)) {
          count = 1;
        }
        count = targetSender.unread_count + 1;
        Object.assign(targetSender, { unread_count: count });
      }
      this.checkUnreadAmount();
    },

    async handleChatroomCreated(event) {
      let { chatroom } = event;
      let response = await chatroomApi.getSingleChatrooms(chatroom.id);
      let newChatroom = response.data.data;
      if (this.chatrooms.find((c) => c.id == newChatroom.id)) {
        return;
      }
      newChatroom.is_new_created = true;
      this.chatrooms.push(newChatroom);
      this.sortingChatrooms();
      this.$forceUpdate();
    },

    async handleSenderAdded(event) {
      console.log(event);
      this.fetchChatrooms();
      if (event.chatroom.id == this.selectedChatroomID) {
        this.$refs.sidebox.fetchAll();
      }
    },

    async handleSenderRemoved(event) {
      console.log(event);
      this.fetchChatrooms();
      if (event.chatroom.id == this.selectedChatroomID) {
        this.$refs.sidebox.fetchAll();
      }

      // FIXME: 目前後端帶進來的 sender 沒有 hashid 過，所以跟 senderId mapping 不起來
      if (event.sender.id == this.senderId) {
        this.resetSelectedChatroom();
      }
    },

    async fetchSingleChatroom() {
      let response = await chatroomApi.getSingleChatrooms(
        this.selectedChatroomID
      );
      const oldChatroom = this.chatrooms.find(
        (chatroom) => chatroom.id === response.data.data.id
      );
      // 這邊做個處理 如果sender回來有未讀 則預設就顯示0
      let newChatroom = response.data.data;
      let sender = newChatroom.senders.find((s) => s.id === this.staffId);
      if (sender) {
        sender.unread_count = 0;
      }
      Object.assign(oldChatroom, newChatroom);
    },

    async fetchChatrooms(branchId = null) {
      let payload = this.preparePayload();
      if (branchId && branchId != 'unallocated') {
        payload.branch_id = branchId;
      }

      let response = await chatroomApi.getChatrooms(payload);

      this.chatrooms = response.data.data;
      this.chatroomNextCursor = response.data.meta.nextCursor;

      this.allowSendMessage =
        response.data.config?.allow_staff_send_message_in_dashboard ?? false;
      this.allowSendFile =
        response.data.config?.allow_staff_send_files_in_dashboard ?? false;
      this.allowSendImage =
        response.data.config?.allow_staff_send_images_in_dashboard ?? false;
      this.showMemberListInDashboard =
        response.data.config?.show_member_list_in_dashboard ?? false;
      this.showFileListInDashboard =
        response.data.config?.show_file_list_in_dashboard ?? false;
      this.allowFilterCategory =
        response.data.config?.show_category_filter_in_dashboard ?? false;
      this.allowFilterStatus =
        response.data.config?.show_status_filter_in_dashboard ?? false;

      // get Options
      this.categoryFilterOptions = response.data.options?.categoryFilter ?? [];
      this.sortingChatrooms();
      this.$forceUpdate();

      this.checkUnreadAmount();
    },

    checkUnreadAmount() {
      // 把每個chatroom裡面 目前這個staff的sender挑出來
      // 接著扁平一次 在過濾unread_count > 0的聊天室
      // 只要有就是true 跳紅燈提醒
      const chatroomUnreadCount = this.chatrooms
        .map((c) => c.senders.filter((s) => s.id === this.staffId))
        .flat(2)
        .filter((sender) => sender.unread_count > 0).length;

      if (chatroomUnreadCount > 0) {
        return this.showBadge();
      }
      this.hideBadge();
    },

    async fetchMoreChatrooms(branchId = null) {
      if (!this.chatroomNextCursor) return;

      let payload = this.preparePayload();
      if (branchId) {
        payload.branch_id = branchId;
      }
      payload.cursor = this.chatroomNextCursor;
      payload.count = 20;

      if (this.keyword) {
        payload.keyword = this.keyword;
      }

      let response = await chatroomApi.getChatrooms(payload);

      const newChatrooms = response.data.data.filter((chatroom) => {
        return !this.chatrooms.map((c) => c.id).includes(chatroom.id);
      });

      if (newChatrooms.length) {
        newChatrooms.forEach((c) => {
          this.chatrooms.push(c);
        });
      }

      this.chatroomNextCursor = response.data.meta.nextCursor;
      this.sortingChatrooms();
    },

    async fetchMessages() {
      this.messages = [];
      if (this.loading) return;
      this.loading = true;
      const { messages, nextCursor } = await this.load();
      this.messages = messages;
      this.nextCursor = nextCursor;
      this.loading = false;
    },
    async load(cursor = null, count = 10) {
      let messages, nextCursor;
      try {
        let response = await chatroomApi.getMessages({
          chatroom: this.selectedChatroom,
          cursor,
          count,
        });

        messages = response.data.data;
        nextCursor = response.data.meta.nextCursor;
      } catch (e) {
        console.error(e);
      }

      return { messages, nextCursor };
    },

    async loadMore() {
      if (!this.nextCursor) return;
      if (this.loading) return;
      this.loading = true;
      this.firstLoad = false;
      const { messages, nextCursor } = await this.load(this.nextCursor);

      this.messages = [...this.messages, ...messages];
      this.nextCursor = nextCursor;
      this.loading = false;
    },
    handleInputKeypress(e) {
      if (e.key !== "Enter") {
        return;
      }
      if (e.shiftKey === true) {
        return;
      }
      e.preventDefault();
      this.send();
    },
    async send() {
      const message = this.message.trim();

      if (this.sending || message == "") return;

      this.sending = true;

      const state = uuidv4();
      this.stateBag.push(state);

      this.message = "";
      this.messages.unshift(this.buildMessageWithState({ state, message }));

      try {
        await chatroomApi.sendMessage({
          chatroom: this.selectedChatroom,
          message,
          state,
        });

        this.read();
      } catch (error) {
        let errorMessage = error.response?.data?.message ?? null;
        this.$swal("發送訊息失敗", errorMessage, "error");
        await this.fetchMoreChatrooms(this.selectedBranch);
        this.resetSelectedChatroom();
      }

      this.sending = false;
    },
    buildMessageWithState({ state, message, type = "text", meta = {} }) {
      return {
        state,
        type,
        meta,
        content: message,
        created_at: new Date().toISOString(),
        sender: {
          avatar_url: store.state.auth.user.avatar_url,
          id: store.state.auth.user.id,
          name: store.state.auth.user.name,
          type: "staff",
        },
        draft: true,
      };
    },
    async read() {
      // 如果我是聊天室裡的人 我才打read 這隻api
      if (this.selectedChatroom.senders.find((s) => s.id === this.staffId)) {
        this.reduceUnreadCount();
        await chatroomApi.markAsRead({ chatroom: this.selectedChatroom });
      }
    },
    reduceUnreadCount() {
      const sender = this.chatrooms
        .find((c) => c.id === this.selectedChatroom.id)
        .senders.find((s) => s.id === this.staffId);
      if (sender) {
        Object.assign(sender, { unread_count: 0 });
      }
      this.checkUnreadAmount();
    },
    initRowSizes() {
      window.addEventListener("resize", this.resetRowSizes);
    },
    resetRowSizes() {
      // when page resizes return to default col sizes

      let page = this.$refs.chatroom;

      if (page) {
        let dragbarWidth = 0;

        let rows = [
          page.clientHeight - dragbarWidth - this.typeboxHeight,
          dragbarWidth,
          this.typeboxHeight,
        ];

        let newRowDefn = rows.map((c) => c.toString() + "px").join(" ");

        page.style.gridTemplateRows = newRowDefn;

        let leftcol = this.$refs.chatlist;
        let rightcol = this.$refs.sideCol;

        let leftColWidth = leftcol.clientWidth + 1;
        let rightColWidth = rightcol.clientWidth + 1;

        leftColWidth = leftColWidth < 10 ? 10 : leftColWidth;
        rightColWidth = rightColWidth < 10 ? 10 : rightColWidth;

        let cols = [
          leftColWidth,
          dragbarWidth,
          page.clientWidth - 2 * dragbarWidth - leftColWidth - rightColWidth,
          dragbarWidth,
          rightColWidth,
        ];

        let newColDefn = cols.map((c) => c.toString() + "px").join(" ");

        page.style.gridTemplateColumns = newColDefn;
      }
    },
    onDrag(event) {
      let page = this.$refs.chatroom;

      if (this.isBottomDragging) {
        // let crows = page.style.gridTemplateRows.split(" ");
        // crows[0] = "auto";
        // page.style.gridTemplateRows = crows
        //   .map((c) => c.toString() + "px")
        //   .join(" ");

        let typeboxHeight =
          page.clientHeight - (event.clientY - page.offsetTop);

        typeboxHeight = this.typeboxHeight =
          typeboxHeight < 130 ? 130 : typeboxHeight;

        let dragbarWidth = 0;

        let rows = [
          page.clientHeight - dragbarWidth - typeboxHeight,
          dragbarWidth,
          typeboxHeight,
        ];

        let newRowDefn = rows.map((c) => c.toString() + "px").join(" ");

        page.style.gridTemplateRows = newRowDefn;
      } else if (this.isLeftDragging || this.isRightDragging) {
        // let crows = page.style.gridTemplateRows.split(" ");
        // crows[0] = "auto";
        // page.style.gridTemplateRows = crows
        //   .map((c) => c.toString() + "px")
        //   .join(" ");

        let leftcol = this.$refs.chatlist;
        let rightcol = this.$refs.sideCol;

        let leftColWidth = this.isLeftDragging
          ? event.clientX - page.offsetLeft
          : leftcol.clientWidth + 1;
        let rightColWidth = this.isRightDragging
          ? page.clientWidth - (event.clientX - page.offsetLeft)
          : rightcol.clientWidth + 1;

        leftColWidth = leftColWidth < 10 ? 10 : leftColWidth;
        rightColWidth = rightColWidth < 10 ? 10 : rightColWidth;

        let dragbarWidth = 0;

        let cols = [
          leftColWidth,
          dragbarWidth,
          page.clientWidth - 2 * dragbarWidth - leftColWidth - rightColWidth,
          dragbarWidth,
          rightColWidth,
        ];

        let newColDefn = cols.map((c) => c.toString() + "px").join(" ");

        page.style.gridTemplateColumns = newColDefn;
      }

      if (
        this.isBottomDragging ||
        this.isLeftDragging ||
        this.isRightDragging
      ) {
        event.preventDefault();
      }
    },

    scrollToBottom() {
      this.$refs.messages.scrollTo(0, Number.MAX_SAFE_INTEGER);
    },
    handleScroll(e) {
      let chatbox = e.target;
      const scrollTop = Math.floor(chatbox.scrollTop);

      this.scrollTop = scrollTop;

      if (
        chatbox.scrollHeight - (chatbox.offsetHeight + Math.abs(scrollTop)) <
        100
      ) {
        this.loadMore();
      } else if (scrollTop === 0) {
        //scroll to bottom
        this.unread = false;
        this.bottom = true;
        this.read();
      } else {
        this.bottom = false;
      }
    },
    async handleChatroomListScroll(event) {
      let chatbox = event.target;
      const scrollTop = Math.floor(chatbox.scrollTop);

      this.chatroomListScrollTop = scrollTop;

      if (
        chatbox.scrollHeight - (chatbox.offsetHeight + Math.abs(scrollTop)) <
        150
      ) {
        if (!this.loading) {
          this.loading = true;
          await this.fetchMoreChatrooms(this.selectedBranch);
          this.loading = false;
        }
      }
    },
    initializeEcho() {
      const echo = new Echo({
        broadcaster: "pusher",
        key: process.env.VUE_APP_SOKETI_APP_KEY,
        wsHost: process.env.VUE_APP_SOKETI_HOST,
        wsPort: process.env.VUE_APP_SOKETI_PORT,
        wssPort: process.env.VUE_APP_SOKETI_PORT,
        forceTLS: false,
        encrypted: true,
        disableStats: true,
        enabledTransports: ["ws", "wss"],
        authorizer: (channel) => {
          return {
            authorize(socketId, callback) {
              const orgCode = store.state.general.currentOrgCode;
              const token = store.state.auth.token;
              const authEndpoint = `${process.env.VUE_APP_API_BASE_URL}/${orgCode}/admin/broadcasting/auth`;

              axios
                .post(
                  authEndpoint,
                  {
                    socket_id: socketId,
                    channel_name: channel.name,
                  },
                  {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  }
                )
                .then((response) => callback(false, response.data))
                .catch((error) => callback(true, error));
            },
          };
        },
      });

      this.echo = echo;
    },
    connectToChannel() {
      this.channel = this.echo.private(this.channelName);
    },
    leaveChannel() {
      this.echo.leave(this.channelName);
    },
    async handleMessageReceived(event) {
      let { message, sender, state, chatroom } = event;
      if (chatroom.id !== this.selectedChatroomID) {
        return;
      }
      // 這是為了讓收到訊息後 如果有暱稱 可以替換掉
      const customer = this.senders.find((s) => {
        return s.id === sender.id;
      });
      if (customer) {
        message.sender = customer;
      }
      const index = this.stateBag.indexOf(state);
      const messagesBox = this.$refs.messages;
      const originalScrollHeight = messagesBox.scrollHeight;

      if (index !== -1) {
        const compensation = this.messages.find((message) => {
          return message.state === state;
        });

        compensation.id = message.id;
        compensation.content = message.content;
        compensation.type = message.type;
        compensation.meta = message.meta;
        compensation.draft = false;

        this.stateBag.splice(index, 1);

        return;
      } else {
        const compensation = this.messages.find((message) => {
          return message.state === state;
        });
        if (compensation) {
          compensation.draft = false;
        }
      }

      this.messages.unshift({ sender, ...message });

      this.$nextTick(() => {
        if (this.showIndicator) {
          return messagesBox.scrollTo(
            0,
            messagesBox.scrollTop -
              (messagesBox.scrollHeight - originalScrollHeight)
          );
        }

        this.scrollToBottom();
      });

      if (!this.bottom) {
        return (this.unread = true);
      }

      this.read();
    },

    async handleClickChangeStatus(status) {
      if (status === "not-setting") {
        status = null;
      }
      if (this.selectedChatroom.status == status) {
        await chatroomApi.update(this.selectedChatroom.id, {
          status: null,
        });
      } else {
        this.selectedChatroom.status = status;
        await chatroomApi.update(this.selectedChatroom.id, {
          status,
        });
      }

      this.fetchSingleChatroom();
    },

    async handleClickPin() {
      if (this.isSelectedChatroomPinned) {
        await chatroomApi.unpin(this.selectedChatroom.id);
      } else {
        await chatroomApi.pin(this.selectedChatroom.id);
      }
      this.fetchSingleChatroom();
      // this.fetchChatrooms(this.selectedBranch);
    },

    defaultCategoryFilter() {
      this.selectedCategoryFilter = this.categoryFilterOptions
        .filter((option) => {
          return option.default_selected;
        })
        .map((option) => {
          return {
            value: option.key,
            text: option.display_name,
          };
        });
    },

    async handleUpload(files) {
      if (this.uploading) {
        return;
      }
      this.uploading = true;

      let { converted, failed } = await handleCustomUpload(
        files,
        this.chatroomConfig?.upload_image ?? {},
        this.chatroomConfig?.upload_file ?? {}
      );

      if (failed.length > 0) {
        let message = "";

        for (let i = 0; i < failed.length; i++) {
          message += `檔案: ${failed[i].name} 上傳失敗，原因：${failed[i].reason}<br>`;
        }

        this.$swal("失敗", message + `請重新選擇其他圖片。`, "warning");
        this.uploading = false;
        return;
      }

      try {
        const state = uuidv4();

        this.stateBag.push(state);
        this.messages.unshift(
          this.buildMessageWithState({ state, message: "上傳中..." })
        );

        const filesInfo = converted.map(this.getFileinfo);
        const { files: uploadInfo } = await chatroomApi.upload(
          this.selectedChatroom.id,
          filesInfo
        );
        const requests = uploadInfo.map(({ fileId, uploadURL }, index) => {
          return this.createUploader({
            id: fileId,
            url: uploadURL,
            file: converted[index],
          }).start();
        });

        await Promise.all(requests);
        await chatroomApi.markAsUploaded(this.chatroomId, {
          state,
          files: uploadInfo,
        });

        this.$refs.fileModal?.hide();
        this.$refs.imageModal?.hide();
      } catch (e) {
        console.error("Upload error:", e);
      } finally {
        this.$refs.fileUploader?.reset();
        this.$refs.imageUploader?.reset();
        this.uploading = false;
      }
    },
    async backup_handleUpload(files) {
      if (this.uploading) {
        return;
      }

      for (const file in files) {
        if (file.size > 10 * 1024 * 1024) {
          this.$refs.fileUploader?.reset();
          this.$refs.imageUploader?.reset();

          return this.$bvToast.toast("檔案必須小於 10mb", {
            variant: "danger",
            solid: true,
          });
        }
      }

      this.uploading = true;

      try {
        const state = uuidv4();

        this.stateBag.push(state);
        this.messages.unshift(
          this.buildMessageWithState({ state, message: "上傳中..." })
        );

        const filesInfo = files.map(this.getFileinfo);
        const { files: uploadInfo } = await chatroomApi.upload(
          this.selectedChatroom.id,
          filesInfo
        );
        const requests = uploadInfo.map(({ fileId, uploadURL }, index) => {
          return this.createUploader({
            id: fileId,
            url: uploadURL,
            file: files[index],
          }).start();
        });

        await Promise.all(requests);
        await chatroomApi.markAsUploaded(this.chatroomId, {
          state,
          files: uploadInfo,
        });

        this.$refs.fileModal?.hide();
        this.$refs.imageModal?.hide();
      } catch (e) {
        console.error("Upload error:", e);
      } finally {
        this.$refs.fileUploader?.reset();
        this.$refs.imageUploader?.reset();
        this.uploading = false;
      }
    },

    sortingChatrooms() {
      const [pinned, unpinned] = [...this.chatrooms]
        .sort(
          (a, b) =>
            new Date(b.message?.updated_at).getTime() -
            new Date(a.message?.updated_at).getTime()
        )
        .reduce(
          (prev, curr) => {
            const [pinned, unpinned] = prev;
            if (curr?.extensions[0]?.pinned_at) {
              return [[...pinned, curr], [...unpinned]];
            }
            return [[...pinned], [...unpinned, curr]];
          },
          [[], []]
        );
      let chatrooms = [...pinned, ...unpinned];

      let newChatroom = chatrooms.filter((c) => c.is_new_created);
      if (newChatroom) {
        let newUnpinned = unpinned.filter((chatroom) => {
          return !newChatroom.map((c) => c.id).includes(chatroom.id);
        });
        chatrooms = [...pinned, ...newChatroom, ...newUnpinned];
      }

      chatrooms = chatrooms.filter((c) => {
        let sender = c.senders.find((s) => s.id === this.staffId);
        if (sender) {
          return sender.is_enabled;
        } else {
          return true;
        }
      });

      this.orderedChatrooms = chatrooms;
    },
    sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    senderName(sender) {
      return sender.nickname ?? sender.name;
    },
    async fetchChatroomsAtMin() {
      let response = await chatroomApi.getChatrooms(this.preparePayload());
      const newChatrooms = response.data.data
        .filter((chatroom) => {
          return !this.chatrooms.map((c) => c.id).includes(chatroom.id);
        })
        .map((chatroom) => {
          if (!chatroom.message) {
            chatroom.is_new_created = true;
          }
          return chatroom;
        });
      if (newChatrooms.length) {
        newChatrooms.forEach((c) => {
          this.chatrooms.push(c);
        });
      }
    },
    async handleSelectedCategory(category) {
      this.regularFetchChatroomTrigger();
      this.changingFilter = true;

      let value = category;
      let els = this.selectedCategoryFilter;
      if (els.includes(value)) {
        els.splice(els.indexOf(value), 1);
      } else {
        els.push(value);
      }

      let response = await chatroomApi.getChatrooms(this.preparePayload());

      this.chatrooms = response.data.data;
      this.chatroomNextCursor = response.data.meta.nextCursor;
      this.sortingChatrooms();
      this.$forceUpdate();
      this.changingFilter = false;
    },
    async handleSelectedStatus(status) {

      console.log(status);

      this.regularFetchChatroomTrigger();
      this.changingFilter = true;

      let value = status;

      let els = this.selectedStatus;
      if (els.includes(value)) {
        els.splice(els.indexOf(value), 1);
      } else {
        els.push(value);
      }

      let response = await chatroomApi.getChatrooms(this.preparePayload());

      this.chatrooms = response.data.data;
      this.chatroomNextCursor = response.data.meta.nextCursor;
      this.sortingChatrooms();
      this.$forceUpdate();
      this.changingFilter = false;
    },

    /* async handleUnreadFilter() {
      this.filteredUnreadChatroom = !this.filteredUnreadChatroom;

      this.regularFetchChatroomTrigger();
      this.changingFilter = true;

      let response = await chatroomApi.getChatrooms(this.preparePayload());

      this.chatrooms = response.data.data;
      this.chatroomNextCursor = response.data.meta.nextCursor;
      this.sortingChatrooms();
      this.$forceUpdate();
      this.changingFilter = false;
    }, */

    regularFetchChatroomTrigger() {
      clearInterval(this.everyMinFetchChatroomTimer);
      this.everyMinFetchChatroomTimer = setInterval(() => {
        this.fetchChatroomsAtMin();
      }, 60000);
    },
    preparePayload() {
      let payload = {};
      if (this.selectedBranch && this.selectedBranch != 'unallocated') {
        payload.branch_id = this.selectedBranch;
      }

      if (this.selectedBranch && this.selectedBranch == 'unallocated') {
        payload.no_staffs = true
        payload.type = CHATROOM_TYPE_TYPE_OA
      }

      if (this.allowFilterCategory && this.selectedCategoryValue) {
        payload.category = this.selectedCategoryValue;
      }
      if (this.allowFilterStatus && this.selectedStatusValue) {
        payload.status = this.selectedStatusValue;
      }
      if (this.keyword) {
        payload.keyword = this.keyword;
      }

      if (this.selectedStatus.find((x) => x.value == "unread")) {
        payload.is_unreaded = true;
      }

      // if (this.filteredUnreadChatroom) {
      //   payload.is_unreaded = true;
      // }

      if (this.isOAChatroom) {
        payload.type = CHATROOM_TYPE_TYPE_OA
      }

      return payload;
    },
    pushRecallMessage(val) {
      const index = this.selectedRecallMessages.findIndex(
        (rm) => rm.id === val.id
      );
      if (index !== -1) {
        this.selectedRecallMessages.splice(index, 1);
      } else {
        this.selectedRecallMessages.push(val);
      }
    },
    switchShowRecallCheckBox() {
      this.showRecallCheckBox = !this.showRecallCheckBox;
      this.$refs.settingDropdown.hide();
      this.selectedRecallMessages = [];
    },
    async recallMessage() {
      if (this.selectedRecallMessages.length == 0) {
        this.switchShowRecallCheckBox();
        return;
      }
      this.$swal
        .fire({
          title: "你確定要收回訊息嗎？<br/>收回後將無法恢復訊息內容。",
          type: "warning",
          showCancelButton: true,
          reverseButtons: false,
          confirmButtonText: "確認收回",
          cancelButtonText: "返回",
          confirmButtonClass: "btn btn-lg btn-danger m-1 h3",
          cancelButtonClass: "btn btn-lg btn-primary m-1 h3",
          buttonsStyling: false,
        })
        .then(async (result) => {
          if (!result.value) {
            return;
          }
          try {
            this.messageRecalling = true;
            await chatroomApi.recallMessage({
              chatroom: this.selectedChatroom,
              messages: this.selectedRecallMessages,
            });
            this.messageRecalling = false;
            this.switchShowRecallCheckBox();
          } catch (error) {
            let errorMessage = error.response?.data?.message ?? null;
            this.$swal("回收訊息失敗", errorMessage, "error");
          }
        });
    },
    handleMessageRecalled(event) {
      let { message, chatroom } = event;
      if (chatroom.id !== this.selectedChatroomID) {
        return;
      }
      this.messages.map(function (m) {
        if (m.id === message.id) {
          Object.assign(m, message);
          Object.assign(m, { content: "(訊息已收回)" });
        }
      });
      this.$forceUpdate();
    },
    scrollToUnreadMessage() {
      this.$nextTick(() => {
        const chatbox = this.$refs.messages;
        console.debug(
          "[debug] [scrollToUnreadMessage] firstUnreadMessage",
          this.firstUnreadMessage
        );
        if (!this.firstUnreadMessage) return;
        const dom = chatbox.querySelector(
          `#message-${this.firstUnreadMessage.id}`
        );
        console.debug("[debug] [scrollToUnreadMessage] dom", dom);
        if (!dom) return;
        const offset = -72;
        const scrollTop = dom.offsetTop + offset;
        console.debug(
          "[debug] [scrollToUnreadMessage] dom.offsetTop",
          dom.offsetTop
        );
        console.debug("[debug] [scrollToUnreadMessage] scrollTop", scrollTop);
        this.$nextTick(() => chatbox.scrollTo(0, scrollTop));
      });
    },
    handleStickerSelected({ stickerPackageId, stickerId }) {
      this.sendSticker({ stickerPackageId, stickerId });
      this.showStickerPanel = false;
    },
    async sendSticker({ stickerPackageId, stickerId }) {
      this.sending = true;

      const state = uuidv4();
      const message = stickerId;

      this.stateBag.push(state);

      this.messages.unshift(
        this.buildMessageWithState({
          state,
          message,
          type: "sticker",
          meta: {
            stickerUrl: this.stickers[stickerPackageId][stickerId].url,
          },
        })
      );

      await chatroomApi.sendSticker({
        chatroom: this.selectedChatroom,
        stickerId,
        state,
      });

      this.read();

      this.sending = false;
    },
    syncMessageNickname(val) {
      this.messages.map((m) => {
        if (m.sender.id == val.sender_id) {
          m.sender.nickname = val.nickname;
        }
      });
    },
    // 未讀通知相關方法
    async initUnreadNotification() {
      console.log('[未讀通知] 初始化未讀通知功能');

      // 檢查 chatroomConfig 是否允許瀏覽器通知
      const allowNotification = this.chatroomConfig?.allow_browser_unread_notification_in_dashboard ?? false;
      console.log('[未讀通知] allow_browser_unread_notification_in_dashboard:', allowNotification);

      if (!allowNotification) {
        console.log('[未讀通知] 未啟用瀏覽器未讀通知功能，跳過初始化');
        return;
      }

      console.log('[未讀通知] 瀏覽器是否支援 Notification:', 'Notification' in window);
      console.log('[未讀通知] 當前 Notification.permission:', typeof Notification !== 'undefined' ? Notification.permission : 'N/A');

      const permissionGranted = await this.requestNotificationPermission();
      if (permissionGranted) {
        this.startUnreadNotificationTimer();
      } else {
        console.warn('[未讀通知] 通知權限未授權，不啟動定時器');
      }
    },
    async requestNotificationPermission() {
      // 檢查瀏覽器是否支援
      if (!('Notification' in window)) {
        console.error('[未讀通知] 此瀏覽器不支援桌面通知');
        this.notificationPermission = 'unsupported';
        return false;
      }

      // 檢查是否在安全環境 (HTTPS 或 localhost)
      const isSecureContext = window.isSecureContext;
      console.log('[未讀通知] 是否為安全環境 (HTTPS/localhost):', isSecureContext);
      if (!isSecureContext) {
        console.error('[未讀通知] 通知功能需要在 HTTPS 或 localhost 環境下使用');
        this.notificationPermission = 'insecure';
        return false;
      }

      const currentPermission = Notification.permission;
      console.log('[未讀通知] 當前通知權限狀態:', currentPermission);

      if (currentPermission === 'granted') {
        this.notificationPermission = 'granted';
        console.log('[未讀通知] 通知權限已授權');
        return true;
      } else if (currentPermission === 'denied') {
        this.notificationPermission = 'denied';
        console.warn('[未讀通知] 通知權限已被拒絕，請在瀏覽器設定中手動開啟');
        this.$swal.fire({
          title: '通知權限已被拒絕',
          html: '請在瀏覽器設定中手動開啟通知權限，才能收到未讀訊息提醒。<br><br>步驟：點擊網址列左側的鎖頭圖示 → 網站設定 → 通知 → 允許',
          type: 'warning',
          confirmButtonText: '我知道了',
        });
        return false;
      } else {
        // 'default' 狀態，需要請求權限
        console.log('[未讀通知] 請求通知權限...');

        // 先跳提示訊息
        const result = await this.$swal.fire({
          title: '開啟通知權限',
          text: '為了讓您能即時收到未讀訊息提醒，請允許瀏覽器通知權限。',
          type: 'info',
          showCancelButton: true,
          confirmButtonText: '允許通知',
          cancelButtonText: '稍後再說',
          reverseButtons: true,
        });

        if (!result.value) {
          console.log('[未讀通知] 用戶取消授權');
          this.notificationPermission = 'cancelled';
          return false;
        }

        try {
          const permission = await Notification.requestPermission();
          this.notificationPermission = permission;
          console.log('[未讀通知] 通知權限結果:', permission);

          if (permission === 'granted') {
            this.$swal.fire({
              title: '通知已開啟',
              text: '您現在可以收到未讀訊息的桌面通知了。',
              type: 'success',
              timer: 2000,
              showConfirmButton: false,
            });
            return true;
          } else if (permission === 'denied') {
            this.$swal.fire({
              title: '通知權限被拒絕',
              html: '您已拒絕通知權限。如需開啟，請在瀏覽器設定中手動允許。<br><br>步驟：點擊網址列左側的鎖頭圖示 → 網站設定 → 通知 → 允許',
              type: 'warning',
              confirmButtonText: '我知道了',
            });
            return false;
          } else {
            return false;
          }
        } catch (error) {
          console.error('[未讀通知] 請求通知權限失敗:', error);
          this.notificationPermission = 'error';
          return false;
        }
      }
    },
    startUnreadNotificationTimer() {
      this.clearUnreadNotificationTimer();

      // 從 chatroomConfig 取得間隔設定，預設 10 分鐘
      const intervalMinutes = this.chatroomConfig?.browser_unread_notification_interval ?? DEFAULT_UNREAD_NOTIFICATION_INTERVAL;
      const intervalMs = intervalMinutes * 60 * 1000;

      console.log('[未讀通知] 啟動定時器，間隔:', intervalMinutes, '分鐘 (', intervalMs / 1000, '秒)');
      this.unreadNotificationTimer = setInterval(() => {
        this.checkUnreadAndNotify();
      }, intervalMs);
    },
    clearUnreadNotificationTimer() {
      if (this.unreadNotificationTimer) {
        clearInterval(this.unreadNotificationTimer);
        this.unreadNotificationTimer = null;
        console.log('[未讀通知] 定時器已清除');
      }
    },
    async checkUnreadAndNotify() {
      console.log('[未讀通知] ========== 開始檢查 ==========');
      console.log('[未讀通知] 時間:', new Date().toLocaleTimeString());

      try {
        // 使用已經載入的 chatrooms 資料
        const chatrooms = this.chatrooms;
        console.log('[未讀通知] 聊天室數量:', chatrooms.length);
        console.log('[未讀通知] 當前 staffId:', this.staffId);

        if (!chatrooms || chatrooms.length === 0) {
          console.log('[未讀通知] 沒有聊天室資料');
          return;
        }

        // 計算未讀聊天室數量
        const unreadChatrooms = chatrooms.filter(chatroom => {
          const sender = chatroom.senders?.find(s => s.id === this.staffId);
          const hasUnread = sender && sender.unread_count > 0;
          if (hasUnread) {
            console.log('[未讀通知] 發現未讀聊天室:', chatroom.id, '未讀數:', sender.unread_count);
          }
          return hasUnread;
        });

        console.log('[未讀通知] 未讀聊天室總數:', unreadChatrooms.length);
        console.log('[未讀通知] 通知權限狀態:', this.notificationPermission);

        if (unreadChatrooms.length > 0) {
          console.log('[未讀通知] 準備發送通知...');
          this.sendBrowserNotification(unreadChatrooms.length);
          this.showSnotify(unreadChatrooms.length);
        } else {
          console.log('[未讀通知] 沒有未讀訊息，不發送通知');
        }
      } catch (error) {
        console.error('[未讀通知] 檢查未讀訊息失敗:', error);
      }

      console.log('[未讀通知] ========== 檢查結束 ==========');
    },
    sendBrowserNotification(unreadCount) {
      console.log('[未讀通知] sendBrowserNotification 被調用，未讀數:', unreadCount);
      console.log('[未讀通知] 當前 notificationPermission:', this.notificationPermission);
      console.log('[未讀通知] Notification.permission:', Notification.permission);

      if (this.notificationPermission !== 'granted') {
        console.warn('[未讀通知] 通知權限未授權，跳過發送');
        return;
      }

      try {
        console.log('[未讀通知] 正在創建 Notification 物件...');

        // 從 chatroomConfig 取得通知設定
        const title = this.chatroomConfig?.browser_unread_notification_title ?? '聊天室未讀訊息';
        const contentSuffix = this.chatroomConfig?.browser_unread_notification_content ?? '聊天室有未讀訊息';
        const icon = this.chatroomConfig?.browser_unread_notification_icon ?? '/favicon.ico';

        // 使用時間戳作為唯一 tag，確保每次都能顯示新通知
        const notificationOptions = {
          body: `您有 ${unreadCount} 個${contentSuffix}`,
          icon: icon,
          tag: `chatroom-unread-${Date.now()}`,
          requireInteraction: true,
          silent: false,
        };

        console.log('[未讀通知] Notification 選項:', notificationOptions);

        const notification = new Notification(title, notificationOptions);

        console.log('[未讀通知] Notification 物件已創建:', notification);

        notification.onshow = () => {
          console.log('[未讀通知] 通知已顯示');
        };

        notification.onclick = () => {
          console.log('[未讀通知] 通知被點擊');
          window.focus();
          notification.close();
        };

        notification.onerror = (event) => {
          console.error('[未讀通知] 通知錯誤:', event);
        };

        notification.onclose = () => {
          console.log('[未讀通知] 通知已關閉');
        };

        console.log('[未讀通知] 通知發送流程完成');
      } catch (error) {
        console.error('[未讀通知] 創建通知失敗:', error);
        console.error('[未讀通知] 錯誤詳情:', error.message, error.stack);
      }
    },
    showSnotify(unreadCount) {

      const title = this.chatroomConfig?.browser_unread_notification_title ?? '聊天室未讀訊息';
      const contentSuffix = this.chatroomConfig?.browser_unread_notification_content ?? '聊天室有未讀訊息';
      
      this.$snotify.html(`
          <div class="snotifyToast__title">
          <h6>${title}</h6>
          </div>
          <div class="snotifyToast__body">
            <p>您有 ${unreadCount} 個${contentSuffix} </p>
          </div>`,
      {
        body: null,
        config: {
          position: SnotifyPosition.rightTop,
          type: SnotifyStyle.warning
        },
        timeout: 5000,
        showProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true
      })
    }
  },
  destroyed() {
    clearInterval(this.everyMinFetchChatroomTimer);
    this.clearUnreadNotificationTimer();
    this.hideBadge();
  },
};
</script>

<style lang="scss" scoped>
.chatroom {
  height: 80vh;
  display: grid;
  grid-template-areas:
    "chat-list left-dragbar chat-box right-dragbar side-col"
    "chat-list left-dragbar bottom-dragbar right-dragbar side-col"
    "chat-list left-dragbar chat-typebox right-dragbar side-col";
  grid-template-rows: auto 0 130px;
  grid-template-columns: 1fr 0 2fr 0 1fr;
  .chat-list {
    overflow-x: auto;

    grid-area: chat-list;

    .chat-list-wrapper {
      overflow: hidden;
      max-height: 100%;
      min-width: 260px;
      .header {
        .search {
          position: relative;

          input {
            padding-left: 45px;
          }
          svg {
            position: absolute;
            left: 18px;
            top: 14px;
            height: 15px;
          }
        }
        .filter {
          i {
            color: gray;
          }
        }

        .unread {
          img {
            height: 20px;
            width: 20px;
            //-webkit-filter: grayscale(1);

            
            
          }

          .icon-unread{
              display: none;
            }

          &:hover{
            .icon-all{
              display: none;
            }

            .icon-unread{
              display: inline-block;
            }
          }

          

          &.active {
            //background-color: #dde9d6;
            border-color: #989a9a;

            .icon-all{
              display: none;
            }
            .icon-unread{
              display: inline-block;
            }

            &:hover{
              .icon-unread{
                display: none;
              }

              .icon-all{
                display: inline-block;
              }
            }
          }
        }
      }

      .list {
        overflow-y: auto;
        overflow-x: hidden;
      }
    }
  }
  .left-dragbar,
  .right-dragbar,
  .bottom-dragbar {
    background-color: #ccc;
    position: relative;

    i {
      position: absolute;
      top: 50%;
      padding: 5px;
      transform: translateY(-50%);
      cursor: ew-resize;
    }
  }
  .left-dragbar {
    grid-area: left-dragbar;
  }
  .right-dragbar {
    grid-area: right-dragbar;
  }

  .bottom-dragbar {
    grid-area: bottom-dragbar;

    i {
      position: absolute;
      top: -20px;
      left: 50%;
      transform: translateX(-50%);
      padding: 5px;
      cursor: ns-resize;
    }
  }

  .chat-box {
    overflow-x: hidden;

    grid-area: chat-box;

    .messages {
      overflow-y: auto;
      overflow-x: hidden;
      min-width: 20vw;
      .message-form {
        font-size: 0;
      }

      .message-box {
        margin-right: auto;
        display: block;
        width: 100%;
        order: 2;

        .message-wrapper {
          max-width: 80%;
          display: inline-block;
        }

        &.owner {
          align-self: flex-end;
          text-align: right;
          margin-left: auto;
          margin-right: 0;

          .message {
            background-color: #2196f3;
            border-radius: 1rem;
            border-bottom-right-radius: 0;
            color: white;
            text-align: left;
          }
        }
      }
    }
  }

  .chat-typebox {
    grid-area: chat-typebox;
    position: relative;
    overflow: hidden;

    .chat-typebox-wrapper {
      min-width: 20vw;
      height: 100%;
    }

    .message-box {
      padding-right: 45px;
      //height: calc(45px + 1.25em * (var(--lines) - 1));
      height: 100%;
      //max-height: calc(45px + 1.25em * 9);
      line-height: 1.25;
      padding-top: calc((45px - 1.25em) / 2);
      padding-bottom: calc((45px - 1.25em) / 2);
      color: #000000;
      font-size: 1rem;
      display: flex;
      align-items: center;
      overflow-y: hidden;
    }

    .unread {
      left: 0;
      right: 10px;
      top: -45px;

      text-align: center;
      opacity: 0.3;
    }
  }

  .strike {
    display: flex;
    flex-direction: row;

    &:before,
    &:after {
      content: "";
      flex: 1 1;
      border-bottom: 1px solid #ccc;
      margin: auto 5px;
    }
  }

  .side-col {
    grid-area: side-col;
    overflow-x: auto;
    overflow-y: hidden;

    .side-col-wrapper {
      min-width: 260px;
      height: 100%;

      .sidebox {
        height: 100%;
        overflow-y: hidden;

        .side-tabs {
          overflow-y: hidden;
          .side-tab-content {
            overflow-y: auto;
          }
        }

        .profile {
          div[aria-expanded="true"] {
            i::before {
              content: "\f077";
            }
          }
          div[aria-expanded="false"] {
            i::before {
              content: "\f078";
            }
          }
        }
      }
    }
  }
  .handler {
    cursor: ew-resize;
    width: 0;
  }

  .read-list {
    margin: 0;
    margin-right: 0.25rem;
    display: flex;
    justify-content: flex-end;

    li + li {
      margin-left: 0.125rem;
    }
  }

  .typing-list {
    order: 1;
  }

  .load-more {
    order: 3;
    text-align: center;
    padding-top: 1rem;
    padding-bottom: 0.5rem;
  }

  .loading-spinner {
    order: 4;
  }
}
</style>
<style lang="scss">
.uploader {
  height: 300px;
  .custom-file-input {
    height: 100%;
  }
  .custom-file-label {
    height: 100%;
    width: 100%;
    &::after {
      content: none !important;
    }

    .dropzone {
      height: 300px;
    }
  }
}

.filter {
  .badge {
    font-size: 14px;
  }
}

.file-type-icon {
  width: 40px;
}
.tab-content {
  line-height: 1.3;
  height: 100%;
}
.tab-content > .active {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 32px);
}
.last-message-wrapper {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width: 25rem;
}
.download-all {
  color: #999;
  cursor: pointer;
}

.image-download-section {
  display: flex;
  color: #999;
  font-size: 0.85em;
}

.custom-control-label {
  cursor: pointer;
}
</style>
